<div class="flex flex-col gap-8">
  <div>
    <homey-page-title-layout>
      How it works
    </homey-page-title-layout>
    <p>Skip the paperwork and stress — Homey maximizes your chances of winning the NYC housing lottery.</p>
  </div>
  <div>
    <homey-page-subtitle-layout>
      What does Homey do?
    </homey-page-subtitle-layout>
    <ol class="flex flex-col gap-4">
      <li>
        <p class="flex flex-row items-center font-medium mb-2"><i class="pi pi-search mr-2"></i>1. We track every
          new lottery opportunity</p>
        <p>Homey continuously scans for the latest NYC housing lotteries, ensuring you never miss a chance for
          affordable housing.</p>
      </li>
      <li><p class="flex flex-row items-center font-medium mb-2"><i class="pi pi-check-square mr-2"></i> 2. We match you with all eligible lotteries</p>
        <p>Based on your household details, we identify every lottery you’re eligible for — no need to search on your own.</p>
      </li>
      <li><p class="flex flex-row items-center font-medium mb-2"><i class="pi pi-pencil mr-2"></i>3. We apply on your behalf</p>
        <p>We track and manage your applications, making sure they move forward smoothly.</p>
      </li>
      <li><p class="flex flex-row items-center font-medium mb-2"><i class="pi pi-history mr-2"></i>4. We follow up to ensure nothing falls through the cracks</p>
        <p>Skip the paperwork! We handle the entire application process for you, error-free and hassle-free.</p>
      </li>
      <li><p class="flex flex-row items-center font-medium mb-2"><i class="pi pi-bell mr-2"></i>5. We notify you the moment you win!</p>
        <p>If you’re selected, we’ll alert you immediately and guide you through the final verification process with the NYC Housing Agency.</p>
      </li>
    </ol>
  </div>
  <div>
    <homey-page-subtitle title="What do I need to do?"/>
    <p>Getting started is easy! Just answer a few quick questions about your <span class="font-medium">income, family size, and housing preferences — and we’ll apply to every lottery you qualify for in just 10 minutes.</span></p>
  </div>
</div>
<homey-lotteries-and-footer/>
